import { COURSES } from 'constants/api';
import axios from 'utils/axios';

export const saveAsDraftCourse = async (data) => {
    try {
        const result = await axios.put(COURSES.v1.saveAsDraft, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Save As Draft Course');
    }
};

export const createCourse = async (data) => {
    try {
        const result = await axios.post(COURSES.v1.baseUrl, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Create Course');
    }
};

export const checkExistCourse = async (data) => {
    try {
        const result = await axios.get(COURSES.v1.checkExist, {
            params: data
        });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Check Exist Course');
    }
};

export const getCourses = async (data) => {
    try {
        const result = await axios.get(COURSES.v1.baseUrl, {
            params: data
        });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Get Courses');
    }
};

export const getCoursesAnalytics = async () => {
    try {
        const result = await axios.get(COURSES.v1.analytics);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to get Courses Analytics');
    }
};

export const getCourse = async (id, { includeVersionHistory = false } = {}) => {
    try {
        const result = await axios.get(`${COURSES.v1.baseUrl}/${id}`, {
            params: {
                includeVersionHistory
            }
        });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Check Get Course');
    }
};

export const editCourse = async (id, data) => {
    try {
        const result = await axios.put(`${COURSES.v1.baseUrl}/${id}`, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Update Course');
    }
};

export const duplicateCourse = async (id) => {
    try {
        const result = await axios.post(`${COURSES.v1.duplicate}/${id}`);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Duplicate Course');
    }
};

export const deleteDraftCourse = async (id) => {
    try {
        const result = await axios.delete(`${COURSES.v1.baseUrl}/${id}`);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to delete draft course');
    }
};

export const deactivateCourse = async (id) => {
    try {
        const result = await axios.put(`${COURSES.v1.baseUrl}/${id}/deactivate`);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to deactivate course');
    }
};

export const activateCourse = async (id) => {
    try {
        const result = await axios.put(`${COURSES.v1.baseUrl}/${id}/activate`);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to activate course');
    }
};

export const unitsRelationShipMatrix = async (data) => {
    try {
        const result = await axios.post(`${COURSES.v1.unitsRelationShipMatrix}`, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Duplicate Course');
    }
};

export const generateUnitOutcomeDetails = async (data) => {
    try {
        const result = await axios.post(`${COURSES.v1.generateUnitOutcomeDetails}`, data);
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Duplicate Course');
    }
};

export const getUnitsRelationShipMatrix = async (data) => {
    try {
        const result = await axios.get(`${COURSES.v1.unitsRelationShipMatrix}`, {
            params: data
        });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Get Units Relationship Matrix');
    }
};

export const getUnitOutcomeDetails = async (data) => {
    try {
        const result = await axios.get(`${COURSES.v1.unitOutcomeDetails}`, {
            params: data
        });
        return result.data;
    } catch (err) {
        throw new Error(err?.message || 'Failed to Get Units Relationship Matrix');
    }
};
